import React, { useEffect, useState } from 'react'
// import Bannersection from './Bannersection'
import AboutSection from './AboutSection'
import ServiceSection from './ServiceSection'
import CourseSection from './CourseSection'
import FindSection from './FindSection'
import Process from './Process'
import HighLights from './HighLights'
import Testimonials from './Testimonials'
import Blogs from '../../Reusable/Blogs'
import HeroSection from './HeroSection'

// import { blog_data } from '../Blogs/blog_data'
import { axiosInstance } from '../config'
import CTASection from '../../common/CTASection'
import { Modal } from 'antd'
import moment from 'moment' 


const Index = () => {

    const [blogs,setblogs] = useState([])
    const [PromoCode, setPromoCode] = useState([]); 
    const [open,setOpen] = useState(false);
    const [promoCodeLoaded, setPromoCodeLoaded] = useState(false);
 
    useEffect(() => {
        getBlogs();
        getPromoCode();
    },[])

    function getBlogs() { 

        axiosInstance.get(`get-posts`)
            .then(res => {
                // console.log(res.data)
                setblogs(res.data.posts.reverse())
            })
            .catch((err) => console.log(err))
             
    }

    function getPromoCode() { 

        axiosInstance.get(`get-visible-promocode`)
            .then(res => {
                // console.log(res.data)
                setPromoCode(res.data.data)
                setPromoCodeLoaded(true);
            })
            .catch((err) => console.log(err))
            
    }

    const [Popupopen, setPopupOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
          // Ensure PromoCode is loaded and has a value before opening the popup
          if (!Popupopen && promoCodeLoaded && PromoCode[0]) {
            setOpen(true);
            setPopupOpen(true); // Set open to true on scroll
            window.removeEventListener('scroll', handleScroll); // Remove the event listener once the popup is opened
          }
        };
    
        // Only add the scroll event listener if promo code is loaded
        if (promoCodeLoaded) {
          window.addEventListener('scroll', handleScroll);
        }
    
        // Cleanup the event listener when the component unmounts or promo code is loaded
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, [Popupopen, PromoCode, promoCodeLoaded]);

    const [copied, setCopied] = useState(false);

    const handleCopyClick = () => {
        // Copy the text to the clipboard
        navigator.clipboard.writeText(PromoCode[0]?.code)
        .then(() => {
            // If successful, change the copied state to true
            setCopied(true);
            
            // Reset the copied state after a delay (optional)
            setTimeout(() => setCopied(false), 2000);  // Reset after 2 seconds
        })
        .catch((err) => {
            console.error("Error copying text: ", err);
        });
    };

    return (
        <div> 
            {/* <Bannersection /> */}
            <HeroSection />
            <CTASection/>
            <AboutSection />
            <ServiceSection />
            <CourseSection />
            <FindSection />
            <div className='padding-div'>
                <Process />
            </div>
            <HighLights />
            <Testimonials />
            <Blogs blogs={blogs.slice(0,3)} heading='Latest from our blog post' />
            <Modal
                open={open}
                centered
                onCancel={() => setOpen(false)}
                width={800}
                bodyStyle={{ padding: '0' }}
                footer={null}
                className='Offer-Modal rounded-3'
            >
                <div className="bg-gradientt">
                    <div className='row text-div'>
                        <div className='col-xl-8 py-5 d-flex flex-column justify-content-center align-items-center'>
                            <div className='d-flex align-items-center'>
                                <h1 className='text-uppercase text-center text-white'>"{PromoCode[0]?.code}"</h1>
                                <i
                                    style={{ cursor: "pointer" }}
                                    onClick={handleCopyClick}
                                    className={`bi ${copied ? "bi-check-square" : "bi-copy"} text-white ps-3 fs-6`}
                                >
                                </i>
                            </div>
                            <h6 className='mt-4 text-center text-white'>Use this Promo Code and Get " {PromoCode[0]?.discount}% " Discount.</h6>
                            <h5 className='mt-4 text-center bg-green'>Valid till <span className='' style={{textDecoration:"underline"}}>{moment(PromoCode[0]?.valid_date).format("DD-MMM-YYYY")}</span></h5>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default Index
